import React from "react";
import { Lock } from "lucide-react";
import { colorOf, fmtDay, fmtTime } from "@/lib/schApi";

/** Day-grouped, color-coded event list shared by resident, partner and public views. */
export default function ScheduleList({ events, action, empty, prefix }) {
  if (!events.length) return <p data-testid={`${prefix}-empty`} className="text-sm text-white/50">{empty}</p>;
  const days = events.reduce((m, e) => { const k = fmtDay(e.start_time); (m[k] = m[k] || []).push(e); return m; }, {});
  return (
    <div data-testid={`${prefix}-list`} className="space-y-3">
      {Object.entries(days).map(([day, list]) => (
        <div key={day}>
          <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/45 mb-1">{day}</div>
          <ul className="space-y-1.5">
            {list.map((e) => (
              <li key={e.id} data-testid={`${prefix}-item-${e.id}`} className="flex flex-wrap items-center gap-3 rounded-sm border border-white/10 bg-white/[0.02] px-3 py-2 border-l-4" style={{ borderLeftColor: colorOf(e) }}>
                <div className="min-w-0 flex-1">
                  <div className="text-sm text-white/90 flex items-center gap-1.5">
                    {e.is_mandatory && <Lock className="h-3 w-3 text-amber-300" aria-label="Mandatory" />}{e.title}
                  </div>
                  <div className="text-xs text-white/50">{fmtTime(e.start_time)} to {fmtTime(e.end_time)} · {e.location || "TBA"} · {e.type_label}
                    {e.max_capacity ? ` · ${e.current_enrollment}/${e.max_capacity}` : ""}</div>
                </div>
                {action?.(e)}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

/** Compact 7-day strip; onOpen(ev) on click. */
export function SevenDayStrip({ events, onOpen, prefix }) {
  const start = new Date(); start.setHours(0, 0, 0, 0);
  const days = Array.from({ length: 7 }, (_, i) => new Date(start.getTime() + i * 86400000));
  return (
    <div data-testid={`${prefix}-week`} className="grid grid-cols-7 gap-1">
      {days.map((d) => {
        const list = events.filter((e) => new Date(e.start_time).toDateString() === d.toDateString());
        return (
          <div key={d.toISOString()} className="min-w-0 rounded-sm border border-white/10 p-1 min-h-[64px]">
            <div className="font-mono text-[9px] uppercase text-white/45 text-center">{d.toLocaleDateString([], { weekday: "short" })} {d.getDate()}</div>
            {list.slice(0, 3).map((e) => (
              <button key={e.id} type="button" onClick={() => onOpen?.(e)} data-testid={`${prefix}-week-event-${e.id}`} title={`${fmtTime(e.start_time)} ${e.title}`}
                className="mt-0.5 w-full truncate rounded-sm px-1 text-left text-[10px] text-white/90 hover:brightness-125" style={{ background: `${colorOf(e)}40` }}>
                {fmtTime(e.start_time).replace(":00", "")} {e.title}
              </button>
            ))}
            {list.length > 3 && <div className="text-[9px] text-white/45 text-center">+{list.length - 3}</div>}
          </div>
        );
      })}
    </div>
  );
}
